<template>
  <div v-if="true || hasActiveAggregators" class="aggregators-status-widget">
    <aggregator-status-item
      v-for="(item, key) in items"
      :key="`${key}-${item.key}`"
      class="aggregators-status-widget__item"
      :aggregator="item.key"
      :active="item.status"
    />
  </div>
</template>

<script>
  import AggregatorStatusItem from '@/components/aside/aggregators-status/AggregatorStatusItem.vue'
  import _ from 'lodash'
  import { mapGetters } from 'vuex'

  export default {
    name: 'AggregatorsStatusWidget',
    components: { AggregatorStatusItem },
    data () {
      return {

      }
    },
    computed: {
      ...mapGetters({
        statusData: 'indicators/getAggregatorsIntegrationStatus',
        filial: 'branches/getGlobalFilial',
      }),
      items () {
        if (this.isSuperAdmin) {
          return [
            ...this.statusData,
            {
              key: 'jupiter',
              status: this.filial?.jupiterSync,
            },
          ]
        }

        return this.statusData
      },
      hasActiveAggregators () {
        return !_.isEmpty(this.statusData) && this.statusData.filter((v) => v.status).length
      },
    },
  }

</script>

<style scoped lang="less">
.aggregators-status-widget {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-left: 27px;
  margin-right: 27px;

  &__item {
    margin-right: 11px;

    .media-xl({
      margin-right: 15px;
    });
  }
}
</style>
